module.exports = __webpack_public_path__ + "img/battery_3classic.e919b442.png";